import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../guards/authenticated.guard';
import { MultipleResultsPageComponent } from './multiple-results.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: MultipleResultsPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class MultipleResultsPageRoutingModule {}
